import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { Button, ButtonGroup, Card, CardBody, CardHeader, Col, Collapse, Container, Modal, ModalBody, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import { ApplicationState } from '../../store';
import { SessionModel } from '../../models/SessionModel';
import * as AzureDocumentStore from '../../store/AzureDocuments';
import * as AzureDocumentMdls from '../../models/AzureDocumentModel';
import { LoadingIcon } from '../Misc/Loading';
import { useEffect } from 'react';
import { faFilePdf } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type MyProps =
    {
        AzureDocuments: AzureDocumentMdls.AzureDocumentList
        SessionState: SessionModel
    } & typeof AzureDocumentStore.actionCreators;


type IconProps = {
    AzureDocument: AzureDocumentMdls.AzureDocument
}

const AzureDocumentListComponent: React.FunctionComponent<MyProps> = (props: MyProps) => {

    interface ParamTypes {
        requestType: string
    }

    //let { requestType } = useParams<ParamTypes>();

    useEffect(() => {
        props.retrieve();
    }, []);


    return (
        <Container fluid={true}>
            <LoadingIcon loading={props.AzureDocuments.loading} title={props.SessionState.SelectedSM.id + " - " + props.SessionState.SelectedSM.name.displayName} address={props.SessionState.SelectedSM.address} />

            <div className="widgetMainContainer">
            {props.AzureDocuments.items.map((item, index) =>
                <Row key={index} >
                    <Col xs={12}>
                        <AzureDocumentIcon AzureDocument={item} />
                    </Col>
                </Row>
                )}
            </div>
        </Container>
    );
}

const AzureDocumentIcon: React.FunctionComponent<IconProps> = (props: IconProps) => {
    return (
        <div>
            <a href={props.AzureDocument.cloudReference} download={props.AzureDocument.documentName}>
                <FontAwesomeIcon icon={faFilePdf} style={{fontSize:"2.5em", color: "red"}} />                        
                <div style={{padding:"7px"}}>
                    {props.AzureDocument.documentName}
                </div>
            </a>
        </div>
    );
}

export default connect(
    (state: ApplicationState) => ({ AzureDocuments: state.azureDocumentsState, SessionState: state.sessionState }),
    AzureDocumentStore.actionCreators)(AzureDocumentListComponent as any);